import { FC, ReactNode } from 'react';
import { cn, CourseImage } from '@fe-learner-common';
import { useAdjustTextContrast } from '@fe-learner-common/hooks/useAdjustTextContrast';
type HeroContainerProps = {
  children: ReactNode;
  topSlot?: ReactNode;
  background: {
    image?: string | null;
    backdrop?: string | null;
    color?: string | null;
  };
  courseImage?: string | null;
  courseImageAlt: string;
};

const getBackgroundStyle = (background: HeroContainerProps['background']) => {
  switch (true) {
    case !!background.color:
      return {
        containerClasses: ``,
        containerStyle: { backgroundColor: background.color },
        contentClasses: '',
      };
    case !!background.image:
      return {
        containerClasses: '',
        containerStyle: {
          backgroundImage: `url(${background.image})`,
        },
        contentClasses: '',
      };
    case !!background.backdrop:
      return {
        containerClasses: 'bg-neutral-500 backdrop-blur-[57px]',
        containerStyle: {
          background: `url(${background.backdrop}) #CDCDCD`,
        },
        contentClasses: 'bg-neutral-0/[.88] backdrop-blur-[200px]',
      };
  }
};

export const HeroContainer: FC<HeroContainerProps> = ({
  children,
  topSlot,
  background,
  courseImage,
  courseImageAlt,
}) => {
  const containerRef = useAdjustTextContrast();
  const styles = getBackgroundStyle(background);
  return (
    <div
      ref={containerRef}
      className={cn(
        'relative flex items-center justify-center bg-neutral-300 bg-cover bg-no-repeat ',
        styles?.containerClasses,
      )}
      style={styles?.containerStyle}
    >
      <div className={cn('flex flex-1 ', styles?.contentClasses)}>
        <div className="l-page 2xl:container">
          <div
            className="flex-1 px-3 pb-6 [&_*]:!text-inherit"
            style={{ color: `red !important ` }}
          >
            {topSlot}
          </div>
          <div className="flex flex-col gap-8 lg:flex-row lg:gap-16">
            <CourseImage
              className={cn('aspect-video  w-full lg:mx-3 lg:max-w-[320px]')}
              thumbnail={courseImage}
              alt={courseImageAlt}
            />

            <div className="flex flex-1 flex-col gap-6 lg:px-4">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
